<template>
  <div>
    <div id="board" :class="{ noClicky: gameEnd }">
      <div v-for="(row, index) in boardRows" v-bind:id="boardRows[index]">
        <div @click="placePiece" :id="index+',0'" class="square"></div>
        <div @click="placePiece" :id="index+',1'" class="square"></div>
        <div @click="placePiece" :id="index+',2'" class="square"></div>
      </div>
    </div>
    <div id=results v-if="gameEnd">
      <p>
        {{ this.results }}
      </p>
      <button @click="resetGame">New Game</button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Game',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      boardRows: ['top', 'mid', 'bot'],
      startsGame: 'x',
      turn: 'x',
      state: [['', '', ''], ['', '', ''], ['', '', '']],
      gameEnd: false,
      results: 'game is in progress'
    }
  },
  methods: {
    placePiece: function (event) {
      // Set clicked Square
      if (!this.gameEnd) {
        const square = event.target

        if (!square.children.length) {
          // TODO: couple the state and view of these squares

          // visually Add 'x' or 'o' to square clicked
          square.appendChild(document.createElement('div'))
          square.children[0].classList.add(this.turn)

          // Set internal state of clicked square to 'x' or 'o'
          const coords = square.id.split(',')
          this.state[coords[0]][coords[1]] = this.turn

          this.checkWinner()

          this.turn = this.turn === 'x' ? 'o' : 'x'
        }
      }
    },
    checkWinner: function () {
      // Checks row, column, and diagonal winners
      // TODO: I bet this could be done better with just a flat array
      // using i/3 and i%3 for the positions
      // checking for cats game is ez just looking for ''
      let row = []
      for (let i = 0; i < 3; i++) {
        row = this.state[i]
        if (row[0] === row[1] && row[0] === row[2] && row[0] === this.turn) {
          this.handleWinner()
          return
        }
      }

      const col = this.state
      for (let i = 0; i < 3; i++) {
        if (col[0][i] === col[1][i] && col[0][i] === col[2][i] && col[0][i] === this.turn) {
          this.handleWinner()
          return
        }
      }
      const diag = this.state
      if (diag[0][0] === diag[1][1] && diag[0][0] === diag[2][2] && diag[0][0] === this.turn) {
        this.handleWinner()
        return
      }

      if (diag[0][2] === diag[1][1] && diag[0][2] === diag[2][0] && diag[0][2] === this.turn) {
        this.handleWinner()
        return
      }
      for (let i = 0; i < 3; i++) {
        for (let j = 0; j < 3; j++) {
          if (this.state[i][j] === '') {
            return
          }
        }
      }
      this.handleTie()
    },
    handleWinner: function () {
      this.results = this.turn + ' is the winner'
      this.gameEnd = true
    },
    handleTie: function () {
      this.results = 'It\'s a cats game!'
      this.gameEnd = true
    },
    resetGame: function () {
      console.log('reset button pushed')
      this.startsGame === 'o' ? this.startsGame = this.turn = 'x' : this.startsGame = this.turn = 'o'
      this.state = [['', '', ''], ['', '', ''], ['', '', '']]
      this.gameEnd = false

      // Pick up the pieces
      let piece = document.querySelector('.x, .o')
      while (piece) {
        piece.remove()
        piece = document.querySelector('.x, .o')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#board {
  height: 600px;
  width: 600px;
  margin : auto;
}

#board > div:nth-child(2) {
  border-top: 5px solid black;
  border-bottom: 5px solid black;
}

#board > div div:nth-child(2){

  border-right: 5px solid black;
  border-left: 5px solid black;
}

#top, #mid, #bot {
  display: flex;
  height: 33%;
} 
.square {
  width: 100%;
  height: 100%;
}
.x
{
  position: relative;
  display: inline-block;
  width: 80%;
  height: 50%;
  overflow: hidden;
  padding-top: 50%;
  pointer-events: none;
}
.x::before, .x::after{
  content: '';
  position: absolute;
  height: 15px;
  width: 100%;
  top: 50%;
  left: 0;
  background: #000;
  border-radius: 5px;
}

.x::before {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.x::after {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.o
{
  border: 12.5px solid black;
  width: 54%;
  height: 55%;
  border-radius: 50%;
  pointer-events: none;
  margin: auto;
  margin-top: 20%;
}
.noClicky {
  pointer-events:none;
}

@media only screen and (max-width:650px) {
  #board{
      width: 400px;
      height: 400px;
  }
}

@media only screen and (max-width:450px)
{
  #board{
      width: 300px;
      height: 300px;
  }
}

@media only screen and (max-width:325px)
{
  #board{
      width: 80%;
      padding-top: 80%;
      /* box-sizing: border-box; */
      position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game.vue